import React, { useMemo } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { Menu } from 'components';

import FormModal from '../../FormModal';

export default function UserAssignHeader({ onSuccess }) {
  const [type, setType] = React.useState<string>();

  const options = useMemo(() => ([
    {
      label: 'Atribuir a Usuários',
      id: 'user-trainings',
      onClick: () => setType('user-trainings'),
    },
    {
      label: 'Atribuir por tipo de Permissão',
      id: 'role-trainings',
      onClick: () => setType('role-trainings'),
    },
    {
      label: 'Atribuir a Condutores',
      id: 'driver-trainings',
      onClick: () => setType('driver-trainings'),
    },
  ]), []);

  return (
    <Flex
      justifyContent="space-between"
      width="100%">
      <FormModal
        action="Atribuir"
        content={type}
        onClose={() => setType(undefined)}
        isFetching={false}
        isOpen={!!type}
        onSuccess={onSuccess}
      />
      <Text variant="xLargeBold">Usuários vinculados</Text>
      <Menu
        size="sm"
        withIcon
        icon={{
          name: 'user',
          family: 'fas',
        }}
        py={2}
        placeholder="Atribuir"
        options={options}
      />
    </Flex>
  );
}
